import { isEmpty } from 'lodash';
import { metricsDataExtractor } from 'modules/iterableGoals/utils/goalAnalytics';
import { ActionTypes } from '../actionTypes';
import {
  CompletionsVsSendsAction,
  CompletionsVsSendsState,
  GoalAnalyticsMetricKey,
  KeyofGoalAnalyticsMetricValue,
} from '../../types';

export const initialCompletionsVsSendsState = {
  metrics: {},
  revenue: {},
  loading: true,
  error: false,
};

export const completionsVsSendsReducer = (
  state: CompletionsVsSendsState = initialCompletionsVsSendsState,
  action?: CompletionsVsSendsAction,
) => {
  const metrics = action?.payload?.metrics;
  const hasData = !isEmpty(metrics);

  switch (action?.type) {
    case ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_REQUEST:
    case ActionTypes.FETCH_GOAL_ANALYTICS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_RESPONSE:
      return {
        ...state,
        error: false,
        loading: false,
        metrics: action?.payload,
      };
    case ActionTypes.FETCH_GOAL_ANALYTICS_RESPONSE:
      return {
        ...state,
        error: false,
        metrics:
          metrics && hasData
            ? metricsDataExtractor(metrics, [
                [
                  GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS,
                  KeyofGoalAnalyticsMetricValue.HISTOGRAM,
                ],
                [GoalAnalyticsMetricKey.TOTAL_SENT, KeyofGoalAnalyticsMetricValue.HISTOGRAM],
              ])
            : state.metrics,
        revenue:
          metrics && hasData
            ? metricsDataExtractor(metrics, [
                [GoalAnalyticsMetricKey.REVENUE, KeyofGoalAnalyticsMetricValue.HISTOGRAM],
                [GoalAnalyticsMetricKey.TOTAL_SENT, KeyofGoalAnalyticsMetricValue.HISTOGRAM],
              ])
            : state.revenue,
        loading: false,
      };
    case ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_ERROR:
    case ActionTypes.FETCH_GOAL_ANALYTICS_ERROR:
      return {
        ...initialCompletionsVsSendsState,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
